/**
 * Identidad visual centralizada de la empresa.
 * Cambiar aqui el nombre y el logo actualiza todo el sistema.
 */
export const BRAND = {
  name: 'INFINITY MOTORS Ltda.',
  shortName: 'INFINITY MOTORS',
  legalName: 'INFINITY MOTORS Ltda.',
  subtitle: 'Sistema de Gestion de Inventario y Ventas',
  tagline: 'Autorrepuestos · Llantas · Aceites y Lubricantes',
  logoUrl:
    'https://static.readdy.ai/image/5e0dc67cda370742b3d5bcd513fed04e/0a1ec5a8eeedc5c0241f75be1c279b2d.jpeg',
  version: 'v1.0',
} as const;

export default BRAND;